<div class="container animated fadeIn fast">
    <form [formGroup]="editOrder" >
        <app-patient-form *ngIf="editPatient" (selectedPatient)="patientChangeEvent($event)"></app-patient-form>

        <mat-card class="mt-3"  *ngIf="!editPatient">
            <mat-card-title>
                Paciente
            </mat-card-title>
            <mat-card-content>
                <div class="form-row">
                    <mat-form-field class="col-md-4">
                        <mat-label>DNI</mat-label>
                        <input matInput placeholder="" value="{{ editOrder.get('patient.fiscalCode').value }}" name="dni" disabled>
                      </mat-form-field>
                    <mat-form-field class="col-md-4">
                      <mat-label>Nombre</mat-label>
                      <input matInput placeholder="" value="{{ editOrder.get('patient.name').value}}" name="name" disabled>
                    </mat-form-field>
                    <mat-form-field class="col-md-4">
                      <mat-label>Apellido</mat-label>
                      <input matInput placeholder="" value="{{ editOrder.get('patient.surname').value }}" name="surname" disabled>
                    </mat-form-field>
                  </div>
                  <!--div class="form-row">
                      <div class="mr-auto ml-auto">
                        <button mat-raised-button color="primary" (click)="enableEditPatient()" > Editar </button>
                      </div>
                </div-->                
            </mat-card-content>
        </mat-card>
        
        <mat-card class="mt-3">
            <mat-card-title>
                Solicitud N° {{order.orderId}}
                <button type="button" mat-icon-button class="add-note" [class.has-note]="editOrder.get('noteSector').value != '' " 
                  (click)="addNotes($event); $event.preventDefault()">
                  <mat-icon>note_add</mat-icon>
                </button>
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                    <mat-form-field class="col-md-4">
                        <mat-label>Número de solicitud externo</mat-label>
                        <input matInput placeholder="" name="orderExternalId" autofocus
                        formControlName="externalOrderId">
                      </mat-form-field>
                      <mat-form-field class="col-md-4">
                        <mat-label>Fecha de ingreso</mat-label>
                        <input matInput type="text" formControlName="orderDate">
                      </mat-form-field>
                      <mat-form-field class="col-md-4">
                        <mat-label>Urgencia</mat-label>
                        <mat-select  formControlName="priorityLevel" >
                        <mat-option *ngFor="let priorityLevel of prioritiesLevel" [value]="priorityLevel.id">
                            {{priorityLevel.name}}
                        </mat-option>
                        </mat-select>
                       </mat-form-field>                      
                </div>
                <div class="row">
                    <mat-form-field class="col-md-4">
                        <mat-label>Médico solicitante</mat-label>
                        <input matInput placeholder="" name="doctor"
                        [ngbTypeahead]="searchDoctor" [resultFormatter]="formatMatchesDoctor"
                        [inputFormatter]="formatMatchesDoctor" formControlName="doctor">
                      </mat-form-field>
                    <mat-form-field class="col-md-4">
                        <mat-label>Servicio</mat-label>
                        <mat-select  formControlName="ward" (selectionChange)="loadEntes()">
                        <mat-option *ngFor="let ward of wards" [value]="ward">
                            {{ward.wardDescription}}
                        </mat-option>
                        </mat-select>
                    </mat-form-field>
    
                    <mat-form-field  class="col-md-4">
                        <mat-label>Ente</mat-label>
                        <mat-select formControlName="ente">
                            <mat-option *ngFor="let ente of entes" [value]="ente">{{ente.enteDescription}}
                          </mat-option>
                        </mat-select>
                      
                    </mat-form-field>
                </div>
                
            </mat-card-content>
        </mat-card>

        <mat-card class="mt-3">
            <mat-card-title>
                Tests
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                  <div class="col-md-4">
                    <mat-form-field>
                      <input type="text" #testInput
                             placeholder="Pick one"
                             aria-label="Number"
                             matInput
                             #testInput
                             (keydown.enter)="searchByCode(testInput); $event.preventDefault()"
                               placeholder="Ingrese código de análisis">
                               <button type="button" mat-button matSuffix mat-icon-button aria-label="Clear" (click)="showTestsDialog(); $event.preventDefault()">
                                <mat-icon>list_alt</mat-icon>
                              </button>                
                      <small *ngIf="searching" class="form-text text-muted">Buscando...</small>
                      <small  *ngIf="searchFailed">
                        No existe tal test
                      </small>
                    </mat-form-field>
                  </div>

                  <div class="col-md-4">

                  </div>
                  
    
                      <div class="col-md-4">
                        <div class="row" *ngIf="testsForm.controls.length!=0">
                          <div class="col-md-12">
                            <label>Análisis seleccionados</label> 
                              <mat-chip-list>
                                <mat-chip color="primary"  *ngFor="let test of testsForm.controls; let i = index"
                                [matTooltip]="test.value.description" removable="true" (removed)="removeTest(test, i)"
                                [class.profile-chip]="test.value.type =='P'">
                                 {{test.value.id}}
                                 <mat-icon matChipRemove >cancel</mat-icon>
                                </mat-chip>
                              </mat-chip-list>
                          </div>
                            
                        </div>

                        <div class="row mt-2" *ngIf="addedTestsForm.controls.length!=0">
                          <div class="col-md-12">
                            <label>Análisis nuevos</label> <br>
                            <div>
                              <mat-chip-list>
                                <mat-chip color="primary" selected  *ngFor="let test of addedTestsForm.controls; let i = index"
                                [matTooltip]="test.value.description" removable="true" (removed)="removeNewTest(i)" 
                                [class.profile-toadd-chip]="test.value.type =='P'">
                                {{test.value.id}}
                                <mat-icon matChipRemove >cancel</mat-icon>
                                </mat-chip>
                              </mat-chip-list>
                              
                            </div>
                          </div>                          
                        </div>

                        <div class="row mt-2" *ngIf="deletedTestsForm.controls.length != 0">
                          <div class="col-md-12">
                            <label>Análisis a borrar</label> <br>
                            <div>
                              <mat-chip-list>
                                <mat-chip color="warn" selected  *ngFor="let test of deletedTestsForm.controls; let i = index"
                                [matTooltip]="test.value.description" removable="true" (removed)="addOldTest(test, i)"
                                [class.profile-todelete-chip]="test.value.type =='P'">
                                {{test.value.id}}
                                <mat-icon matChipRemove >cancel</mat-icon>
                                </mat-chip>
                              </mat-chip-list>
                              
                            </div>
                          </div>                          
                        </div>
                      </div>
                        
                </div>
                
            </mat-card-content>
        </mat-card>

        <div class="row mt-3">
          <div class="ml-auto mr-auto">
            <button type="button" mat-raised-button color="warn" (click)="cancel()">Cancelar</button>
            <button type="button" mat-raised-button color="accent" (click)="modifyOrderType1()" [disabled]="!canSave()" *ngIf="group?.sampleGeneration"> Guardar </button>
            <button type="button" mat-raised-button color="primary" (click)="modifyOrder()" *ngIf="!group?.sampleGeneration" [disabled]="!canSave()">Guardar</button>
          </div>
        </div>
        

        

    </form>
</div>
<pre>
</pre>